// extracted by mini-css-extract-plugin
export default {"posterWrapper":"PositionList_posterWrapper__DV4zk","positionTitleWrapper":"PositionList_positionTitleWrapper__1A0iY","applyBtn":"PositionList_applyBtn__XZb9D"};